import { combineReducers } from 'redux';

import atendimentos from './atendimentos/combineReducers';

export default combineReducers({ atendimentos });
